import { useContext } from 'react';
import { Link } from 'react-router-dom';
import { UserContext } from '../context/UserContext';
import { isLegacyLoginClosed } from '../auth/capabilityPolicy';

// The way back from a failed Microsoft sign-in. `?explain` keeps /login on its
// own page even in a browser that has signed in with Microsoft before, which
// would otherwise be sent straight back to Microsoft (pages/Login.jsx).
export default function LoginPageLink() {
  const { authCapabilities } = useContext(UserContext);
  return (
    <Link to="/login?explain=1" className="auth-status-link">
      {isLegacyLoginClosed(authCapabilities) ? 'חזרה למסך הכניסה' : 'כניסה עם סיסמה'}
    </Link>
  );
}
